module.exports = __webpack_public_path__ + "assets/img/kv-e6dca168.jpg";